import { ArrowLeft } from "lucide-react";
import { COMPANY, OWNERS } from "@/lib/company";

export default function PrivacyPolicy() {
  return (
    <div
      data-testid="privacy-page"
      className="min-h-screen bg-[#050B14] text-slate-100"
    >
      <header className="border-b border-[#1E293B] py-5 px-6 md:px-10">
        <a
          href="/"
          className="inline-flex items-center gap-2 text-slate-400 hover:text-white text-sm"
        >
          <ArrowLeft size={16} /> Torna al sito
        </a>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-px bg-[#FF5A1F]" />
          <span className="text-xs tracking-[0.3em] uppercase text-[#FF5A1F] font-bold">
            Documento legale
          </span>
        </div>
        <h1 className="headline text-white text-4xl md:text-6xl">
          Privacy{" "}
          <span className="font-display italic font-medium text-slate-300">
            Policy
          </span>
        </h1>
        <p className="text-slate-500 text-sm mt-4">
          Ultimo aggiornamento: dicembre 2025
        </p>

        <div className="mt-12 space-y-8 text-slate-300 leading-relaxed text-[15px]">
          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              1. Titolare del trattamento
            </h2>
            <p>
              Il Titolare del trattamento dei dati personali è{" "}
              <strong className="text-white">{COMPANY.name}</strong>, con sede
              in {COMPANY.area}.
            </p>
            <ul className="mt-3 space-y-1 text-sm">
              <li>Email: {COMPANY.email}</li>
              {OWNERS.map((o) => (
                <li key={o.phone}>
                  {o.name} ({o.role}): {o.phone}
                </li>
              ))}
              <li>P.IVA / REA: {COMPANY.vatNumber}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              2. Dati raccolti
            </h2>
            <p>
              Trattiamo unicamente i dati che ci fornisci volontariamente
              attraverso i moduli del sito o tramite WhatsApp:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-1 text-sm">
              <li>
                <strong className="text-white">Modulo preventivo:</strong>{" "}
                nome, cognome, email, telefono, città, tipologia di lavoro,
                tempistiche, messaggio.
              </li>
              <li>
                <strong className="text-white">Modulo contatti:</strong> nome,
                email, telefono, messaggio.
              </li>
              <li>
                <strong className="text-white">Bot WhatsApp:</strong> numero di
                telefono, nome, risposte fornite al questionario (tipo lavoro,
                città, mq indicativi, tempistiche, descrizione).
              </li>
              <li>
                <strong className="text-white">Dati tecnici:</strong> indirizzo
                IP, browser, pagine visitate (solo se acconsenti ai cookie
                analitici).
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              3. Finalità del trattamento
            </h2>
            <ul className="list-disc pl-6 space-y-1 text-sm">
              <li>Rispondere alle richieste di preventivo e di contatto.</li>
              <li>Fornire i servizi richiesti (sopralluoghi, preventivi).</li>
              <li>Gestire la corrispondenza commerciale.</li>
              <li>Adempiere ad obblighi legali e fiscali.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              4. Base giuridica
            </h2>
            <p>
              Il trattamento si fonda sul tuo <strong>consenso</strong>{" "}
              (art. 6.1.a GDPR), espresso tramite l'invio del modulo o l'avvio
              della conversazione WhatsApp, e sull'<strong>esecuzione di
              misure precontrattuali</strong> richieste dall'interessato
              (art. 6.1.b GDPR).
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              5. Modalità e tempi di conservazione
            </h2>
            <p>
              I dati sono trattati con strumenti elettronici, conservati su
              server protetti e accessibili solo ai titolari dell'impresa.
              Periodi di conservazione:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-1 text-sm">
              <li>Richieste di preventivo non andate a buon fine: 24 mesi.</li>
              <li>
                Clienti acquisiti: per la durata del rapporto contrattuale e
                10 anni successivi, per obblighi civilistici e fiscali.
              </li>
              <li>Messaggi di contatto generici: 12 mesi.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              6. Destinatari dei dati
            </h2>
            <p>
              I dati non vengono ceduti né diffusi a terzi. Possono essere
              comunicati a:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-1 text-sm">
              <li>
                Fornitori di servizi tecnici (hosting, messaggistica WhatsApp
                via Twilio Inc.) in qualità di Responsabili del trattamento.
              </li>
              <li>
                Consulente fiscale / commercialista, ove necessario per
                obblighi di legge.
              </li>
              <li>Autorità competenti, su richiesta motivata.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              7. Trasferimento extra UE
            </h2>
            <p>
              L'utilizzo del servizio Twilio per il bot WhatsApp può comportare
              il trasferimento dei dati negli Stati Uniti. Il trasferimento
              avviene sulla base delle Clausole Contrattuali Standard approvate
              dalla Commissione Europea, in conformità all'art. 46 GDPR.
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              8. I tuoi diritti
            </h2>
            <p>
              Ai sensi degli articoli 15-22 GDPR hai diritto a:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-1 text-sm">
              <li>Accedere ai tuoi dati e ottenerne copia.</li>
              <li>Rettificare dati inesatti o incompleti.</li>
              <li>
                Richiederne la cancellazione (diritto all'oblio) nei casi
                previsti dalla legge.
              </li>
              <li>Limitare o opporti al trattamento.</li>
              <li>Revocare il consenso in qualunque momento.</li>
              <li>
                Proporre reclamo al Garante per la protezione dei dati
                personali ({" "}
                <a
                  href="https://www.garanteprivacy.it"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#FF5A1F] underline"
                >
                  garanteprivacy.it
                </a>
                ).
              </li>
            </ul>
            <p className="mt-3">
              Per esercitare i tuoi diritti scrivi a{" "}
              <a
                href={`mailto:${COMPANY.email}`}
                className="text-[#FF5A1F] underline"
              >
                {COMPANY.email}
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              9. Cookie
            </h2>
            <p>
              Per informazioni sui cookie utilizzati consulta la nostra{" "}
              <a
                href="/cookie-policy"
                className="text-[#FF5A1F] underline"
              >
                Cookie Policy
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-bold tracking-tight mb-3">
              10. Modifiche
            </h2>
            <p>
              La presente Privacy Policy può essere aggiornata. Ti invitiamo a
              consultarla periodicamente. La data di ultimo aggiornamento è
              indicata in alto.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-[#1E293B] py-8 px-6 md:px-10 text-xs text-slate-500">
        © {new Date().getFullYear()} {COMPANY.name} — Tutti i diritti riservati.
      </footer>
    </div>
  );
}
